import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { postRequest } from "services/api";
import {
  DataGridPremium,
  useGridApiRef,
  GRID_DETAIL_PANEL_TOGGLE_FIELD,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarQuickFilter,
  GridToolbarExport,
} from "@mui/x-data-grid-premium";
import {
  Alert,
  Box,
  Button,
  Drawer,
  FormLabel,
  Grid,
  IconButton,
  MenuItem,
  OutlinedInput,
  Select,
  Snackbar,
  Stack,
} from "@mui/material";
import DateRangePicker from "react-bootstrap-daterangepicker";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

const columns = [
  {
    field: "CustomerName",
    headerClassName: "headingbg-color",
    headerName: "Customer Name",
  },
  {
    field: "CustomerOrderNumber",
    headerClassName: "headingbg-color",
    headerName: "Customer Order",
  },
  {
    field: "IGDOrderNumber",
    headerClassName: "headingbg-color",
    headerName: "IGD Order",
  },

  {
    field: "CustomerPOnumber",
    headerClassName: "headingbg-color",
    headerName: "Customer PO Number",
  },
  {
    field: "ExternalLoadNumber",
    headerClassName: "headingbg-color",
    headerName: "External Load Number",
  },
  {
    field: "ShipToAddress",
    headerClassName: "headingbg-color",
    headerName: "Ship To Address",
  },
  {
    field: "BillToName",
    headerClassName: "headingbg-color",
    headerName: "Bill To Name",
  },
  {
    field: "OrderShipDate",
    headerClassName: "headingbg-color",
    headerName: "Order Start Ship Date",
  },
  {
    field: "OrderCancelDate",
    headerClassName: "headingbg-color",
    headerName: "Order Cancel After Date",
  },
  {
    field: "LoadNumber",
    headerClassName: "headingbg-color",
    headerName: "Load Number",
  },
  {
    field: "AppointmentNumber",
    headerClassName: "headingbg-color",
    headerName: "Appointment Number",
  },

  {
    field: "AppointmentDateTime",
    headerClassName: "headingbg-color",
    headerName: "Appointment Time",
  },
  {
    field: "SCAC",
    headerClassName: "headingbg-color",
    headerName: "SCAC",
  },
  {
    field: "CarrierName",
    headerClassName: "headingbg-color",
    headerName: "Carrier Name",
  },
  {
    field: "GroupingNumber",
    headerClassName: "headingbg-color",
    headerName: "Grouping Number",
  },
  {
    field: "MissedAppt_Yes_NO",
    headerClassName: "headingbg-color",
    headerName: "Missed Appt Yes/NO",
  },
  {
    field: "MissedApptNotes",
    headerClassName: "headingbg-color",
    headerName: "Missed appt notes",
  },
  {
    field: "ApptRescheduled",
    headerClassName: "headingbg-color",
    headerName: "Appt Rescheduled",
  },
  {
    field: "ApptReschduledNotes",
    headerClassName: "headingbg-color",
    headerName: "Appt Reschduled notes",
  },
];

const RoutingRecieved = () => {
  const apiRef = useGridApiRef();
  const [isLoading, setIsLoading] = useState(false);
  const { startDate, endDate } = useSelector((state) => state.dashboard);
  const { user, userSetting } = useSelector((state) => state.user);
  const [orderData, setOrderData] = React.useState([]);
  const [routingDate, setRoutingDate] = useState();
  const [shipToName, setShipToName] = useState("");
  const [billToName, setBillToName] = useState("");
  const [clearFormData, setClearFormData] = useState(false);
  const [routingNotes, setRoutingNotes] = useState("");
  const [groupingNumber, setGroupingNumber] = useState("");
  const [loadNumber, setLoadNumber] = useState("");
  const [loadNumberUpdate, setLoadNumberUpdate] = useState("");
  const [appointmentNumber, setAppointmentNumber] = useState("");
  const [carrierName, setCarrierName] = useState("");
  const [MissedAppt_Yes_NO, setMissedAppt_Yes_NO] = useState("Yes");
  const [MissedApptNotes, setMissedApptNotes] = useState("");
  const [ApptRescheduled, setApptRescheduled] = useState();
  const [ApptReschduledNotes, setApptReschduledNotes] = useState("");
  const [groupingNum, setGroupingNum] = useState("");
  const [poNum, setPoNum] = useState("");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [rowsData, setRowsData] = useState([]);
  const [apiMsg, setApiMsg] = useState("");
  const [error, setError] = useState("");
  const [open, setOpen] = useState(false);
  const [mustArriveDate, setMustArriveDate] = useState({
    from_mustArriveByDt: "",
    to_mustArriveByDt: "",
  });

  const [scheduleShipDate, setScheduleShipDate] = useState({
    from_startShipDt: "",
    to_startShipDt: "",
  });

  const [enteredDateForRouting, setEnteredDateForRouting] = useState({
    from_dtEnteredForRouting: "",
    to_dtEnteredForRouting: "",
  });

  const [rowSelectionModel, setRowSelectionModel] = React.useState([]);

  const labelArriveDate = mustArriveDate.from_mustArriveByDt
    ? mustArriveDate.from_mustArriveByDt.format("MMMM D, YYYY") +
      " - " +
      mustArriveDate.to_mustArriveByDt.format("MMMM D, YYYY")
    : "Must arrive by date";

  const labelScheduleShipDate = scheduleShipDate.from_startShipDt
    ? scheduleShipDate.from_startShipDt.format("MMMM D, YYYY") +
      " - " +
      scheduleShipDate.to_startShipDt.format("MMMM D, YYYY")
    : "Order Start Ship Date";

  const labelEnteredRoutingDate = enteredDateForRouting.from_dtEnteredForRouting
    ? enteredDateForRouting.from_scheduleShipDt.format("MMMM D, YYYY") +
      " - " +
      enteredDateForRouting.to_dtEnteredForRouting.format("MMMM D, YYYY")
    : "Routing Date";

  useEffect(() => {
    let rows = orderData?.map((c, index) => ({
      id: index,
      WHSEID: c.WHSEID,
      CustomerName: c.CustomerName,
      CustomerOrderNumber: c.CustomerOrderNumber,
      IGDOrderNumber: c.IGDOrderNumber,
      CustomerPOnumber: c.CustomerPOnumber,
      ShipToName: c.ShipToName,
      ShipToAddress: c.ShipToAddress,
      BillToName: c.BillToName,
      OrderShipDate: c.OrderShipDate,
      OrderCancelDate: c.OrderCancelDate,
      ScheduledShipDate: c.ScheduledShipDate,
      GroupingNumber: c.GroupingNumber,
      LoadNumber: c.LoadNumber,
      AppointmentNumber: c.AppointmentNumber,
      AppointmentDateTime: c.AppointmentDateTime,
      ApptReschduledNotes: c.ApptReschduledNotes,
      ApptRescheduled: c.ApptRescheduled,
      CarrierName: c.CarrierName,
      ExternalLoadNumber: c.ExternalLoadNumber,
      MissedApptNotes: c.MissedApptNotes,
      MissedAppt_Yes_NO: c.MissedAppt_Yes_NO,
      SCAC: c.SCAC,
      isSelectable: true,
    }));

    setRowsData(rows);
  }, [orderData]);

  const fetchOrderTableData = async () => {
    setIsLoading(true);
    let headers = {
      "Content-Type": "application/json;",
      Authorization: `Bearer ${user.token}`,
    };
    let payload = {
      custCode: userSetting[0].currCustomer,
      whseCode: userSetting[0].currWarehouse,
      shipToName: shipToName ? shipToName : "all",
      billToName: billToName ? billToName : "all",
      from_mustArriveByDt: mustArriveDate.from_mustArriveByDt
        ? mustArriveDate.from_mustArriveByDt.format("YYYY-MM-DD")
        : "",
      to_mustArriveByDt: mustArriveDate.to_mustArriveByDt
        ? mustArriveDate.to_mustArriveByDt.format("YYYY-MM-DD")
        : "",
      from_startShipDt: scheduleShipDate.from_startShipDt
        ? scheduleShipDate.from_startShipDt.format("YYYY-MM-DD")
        : "",
      to_startShipDt: scheduleShipDate.to_startShipDt
        ? scheduleShipDate.to_startShipDt.format("YYYY-MM-DD")
        : "",
      groupingNumber: groupingNum ? groupingNum : "all",
      from_dtEnteredForRouting: enteredDateForRouting.from_dtEnteredForRouting
        ? enteredDateForRouting.from_dtEnteredForRouting.format("YYYY-MM-DD")
        : "",
      to_dtEnteredForRouting: enteredDateForRouting.to_dtEnteredForRouting
        ? enteredDateForRouting.to_dtEnteredForRouting.format("YYYY-MM-DD")
        : "",
      loadNumber: loadNumber ? loadNumber : "all",
      appointmentNumber: appointmentNumber ? appointmentNumber : "all",
      carrierName: carrierName ? carrierName : "all",
      customerPOnumber: poNum ? poNum : "all",
    };
    const response = await postRequest(
      "user/getOrders_toRescheduleAppointment",
      payload,
      headers
    );
    setClearFormData(false);
    setOrderData(response.data.Payload);
    setIsLoading(false);
  };

  const handleUpdateData = async () => {
    let headers = {
      "Content-Type": "application/json;",
      Authorization: `Bearer ${user.token}`,
    };

    let selectedRows = apiRef.current.getSelectedRows();
    let pushedArrayToString = [];
    for (let [key, value] of selectedRows) {
      console.log(key + " is " + value);
      pushedArrayToString.push(value.IGDOrderNumber);
    }
    let payload = {
      custCode: userSetting[0].currCustomer,
      whseCode: userSetting[0].currWarehouse,
      orderKeys: pushedArrayToString.toString(),
      MissedAppt_Yes_NO: MissedAppt_Yes_NO ? MissedAppt_Yes_NO : "Yes",
      MissedApptNotes: MissedApptNotes,
      ApptRescheduledDateTime: ApptRescheduled ? ApptRescheduled : "",
      ApptReschduledNotes: ApptReschduledNotes,
      LoadNumber: loadNumberUpdate,
      user: "admin",
    };
    const response = await postRequest(
      "user/save_ordersRescheduleAppointment",
      payload,
      headers
    );

    if (response.data.Payload) {
      fetchOrderTableData();
      setRowSelectionModel([]);
      setMissedAppt_Yes_NO("Yes");
      setMissedApptNotes("");
      setApptRescheduled();
      setApptReschduledNotes("");
      setLoadNumberUpdate("");
      setOpen(true);
      setApiMsg(response.data.Payload[0].message);
      setError(false);
      setDrawerOpen(false);
      // setTimeout(() => {
      //   setOpen(false);
      //   setTimeout(() => {
      //     setApiMsg("");
      //   }, 0);
      // }, 3000);
    } else {
      setApiMsg(response.data.Message);
      setError(true);
      setOpen(true);
      // setTimeout(() => {
      //   setOpen(false);
      // }, 3000);
    }
  };

  useEffect(() => {
    fetchOrderTableData();
  }, [userSetting]);

  const handleCallback = (start, end) => {
    setMustArriveDate({ from_mustArriveByDt: start, to_mustArriveByDt: end });
  };

  const handleScheduleShipDateCallback = (start, end) => {
    setScheduleShipDate({ from_startShipDt: start, to_startShipDt: end });
  };

  const handleSearch = (e) => {
    if (e) {
      e.preventDefault();
    }
    fetchOrderTableData();
  };

  const handleUpdate = () => {
    handleUpdateData();
  };

  const clearForm = () => {
    setScheduleShipDate({ from_startShipDt: "", to_startShipDt: "" });
    setMustArriveDate({ from_mustArriveByDt: "", to_mustArriveByDt: "" });
    setGroupingNum("");
    setLoadNumber("");
    setAppointmentNumber("");
    setCarrierName("");
    setShipToName("");
    setBillToName("");
    setPoNum("");
    setClearFormData(true);
  };
  useEffect(() => {
    if (clearFormData) {
      fetchOrderTableData();
    }
  }, [clearFormData]);

  function CustomToolbar(props) {
    return (
      <GridToolbarContainer {...props}>
        <GridToolbarColumnsButton
          slotProps={{ button: { sx: { fontSize: "14px" } } }}
        />
        <GridToolbarFilterButton
          slotProps={{ button: { sx: { fontSize: "14px" } } }}
        />
        <GridToolbarDensitySelector
          slotProps={{ button: { sx: { fontSize: "14px" } } }}
        />
        {/* <GridToolbarExport /> */}
        <GridToolbarExport
          slotProps={{ button: { sx: { fontSize: "14px" } } }}
        />
        {rowSelectionModel.length > 0 && (
          <Button
            onClick={() => {
              let selectedRows = apiRef.current.getSelectedRows();
              let pushedArrayToString = [];

              for (let [key, value] of selectedRows) {
                console.log(key + " is " + value);
                pushedArrayToString.push(value.LoadNumber);
              }
              setLoadNumberUpdate(pushedArrayToString[0]);
              setApiMsg("");
              setError(false);
              setDrawerOpen(true);
            }}
          >
            Mass Order Update
          </Button>
        )}
        <Box sx={{ flexGrow: 1 }} />
        <GridToolbarQuickFilter />
      </GridToolbarContainer>
    );
  }

  const toggleDrawer = (newOpen) => () => {
    setDrawerOpen(newOpen);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
    setApiMsg("");
  };

  return (
    <>
      <div>
        <form onSubmit={handleSearch}>
          <Grid container spacing={1} sx={{ marginTop: "15px" }}>
            <Grid item xs={12} md={1.4}>
              <div>
                <OutlinedInput
                  name="grouping-num"
                  placeholder="Grouping Number"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                      fontSize: "0.8rem",
                    },
                  }}
                  value={groupingNum}
                  onChange={(e) => setGroupingNum(e.target.value)}
                />
              </div>
            </Grid>
            <Grid item xs={12} md={1.4}>
              <div>
                <OutlinedInput
                  name="cust-po-num"
                  placeholder="Po Number"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                      fontSize: "0.8rem",
                    },
                  }}
                  value={poNum}
                  onChange={(e) => setPoNum(e.target.value)}
                />
              </div>
            </Grid>
            <Grid item xs={12} md={1.3}>
              <div>
                <OutlinedInput
                  name="ship-to-name"
                  placeholder="Ship To Name"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                      fontSize: "0.8rem",
                    },
                  }}
                  onChange={(e) => setShipToName(e.target.value)}
                  value={shipToName}
                />
              </div>
            </Grid>
            <Grid item xs={12} md={1.3}>
              <div>
                <OutlinedInput
                  name="bill-to-name"
                  placeholder="Bill To Name"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                      fontSize: "0.8rem",
                    },
                  }}
                  value={billToName}
                  onChange={(e) => setBillToName(e.target.value)}
                />
              </div>
            </Grid>
            <Grid item xs={12} md={1.3}>
              <div>
                <OutlinedInput
                  name="bill-to-name"
                  placeholder="Load Number"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                      fontSize: "0.8rem",
                    },
                  }}
                  value={loadNumber}
                  onChange={(e) => setLoadNumber(e.target.value)}
                />
              </div>
            </Grid>

            <Grid item xs={12} md={1.3}>
              <div>
                <OutlinedInput
                  name="bill-to-name"
                  placeholder="Appointment Number"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                      fontSize: "0.8rem",
                    },
                  }}
                  value={appointmentNumber}
                  onChange={(e) => setAppointmentNumber(e.target.value)}
                />
              </div>
            </Grid>
            <Grid item xs={12} md={1.3}>
              <div>
                <OutlinedInput
                  name="bill-to-name"
                  placeholder="Carrier Name"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                      fontSize: "0.8rem",
                    },
                  }}
                  value={carrierName}
                  onChange={(e) => setCarrierName(e.target.value)}
                />
              </div>
            </Grid>

            <Grid item xs={12} md={2.1}>
              <div>
                <DateRangePicker
                  initialSettings={{
                    startDate: mustArriveDate.from_mustArriveByDt
                      ? mustArriveDate.from_mustArriveByDt.toDate()
                      : moment().toDate(),
                    endDate: mustArriveDate.to_mustArriveByDt
                      ? mustArriveDate.to_mustArriveByDt.toDate()
                      : moment().toDate(),
                  }}
                  onCallback={handleCallback}
                >
                  <div
                    id="reportrange"
                    className="box-with-icon filterCalendar"
                  >
                    <span
                      style={{
                        fontSize: "0.8rem",
                        paddingTop: "3px",
                        color: mustArriveDate.from_mustArriveByDt
                          ? "rgba(0, 0, 0, 0.87)"
                          : "#636c72",
                      }}
                    >
                      {labelArriveDate}
                    </span>
                    <CalendarMonthOutlinedIcon />
                  </div>
                </DateRangePicker>
              </div>
            </Grid>
            <Grid item xs={12} md={2.1}>
              <div>
                <DateRangePicker
                  initialSettings={{
                    startDate: scheduleShipDate.from_startShipDt
                      ? scheduleShipDate.from_startShipDt.toDate()
                      : moment().toDate(),
                    endDate: scheduleShipDate.to_startShipDt
                      ? scheduleShipDate.to_startShipDt.toDate()
                      : moment().toDate(),
                  }}
                  onCallback={handleScheduleShipDateCallback}
                  slotProps={{ textField: { placeholder: "tt.mm.jjjj" } }}
                >
                  <div
                    id="reportrange"
                    className="box-with-icon filterCalendar"
                  >
                    <span
                      style={{
                        fontSize: "0.8rem",
                        paddingTop: "3px",
                        color: scheduleShipDate.from_startShipDt
                          ? "rgba(0, 0, 0, 0.87)"
                          : "#636c72",
                      }}
                    >
                      {labelScheduleShipDate}
                    </span>
                    <CalendarMonthOutlinedIcon />
                  </div>
                </DateRangePicker>
              </div>
            </Grid>
            <Grid item xs={12} md={2}>
              <Stack direction="row" spacing={0}>
                <IconButton
                  aria-label="submit"
                  color="primary"
                  onClick={handleSearch}
                  type="submit"
                >
                  <SearchIcon />
                </IconButton>
                <IconButton
                  aria-label="clear"
                  color="secondry"
                  onClick={clearForm}
                >
                  <ClearIcon />
                </IconButton>
              </Stack>
            </Grid>

            {/* <Grid item xs={12} md={12}>
            <Stack
              direction="row"
              spacing={2}
              sx={{ justifyContent: "flex-end", alignItems: "flex-start" }}
            >
              <Button
                variant="contained"
                onClick={() => setDrawerOpen(true)}
                size="small"
              >
                Mass Update Order
              </Button>
            </Stack>
          </Grid> */}
          </Grid>
        </form>
      </div>
      <div
        style={{
          height: 700,
          width: "100%",
          marginTop: "20px",
          background: "#fff",
        }}
      >
        <DataGridPremium
          loading={isLoading}
          apiRef={apiRef}
          columns={columns}
          rows={rowsData}
          slots={{ toolbar: CustomToolbar }}
          sx={{
            "& .MuiDataGrid-detailPanel": {
              overflow: "visible",
            },
            "& .MuiButton-text": { fontSize: "14px" },
            "& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer": {
              display: "none",
              backgroundColor: 'rgb(103 130 219)'
            }
          }}
          pinnedColumns={{ left: [GRID_DETAIL_PANEL_TOGGLE_FIELD] }}
          pagination
          pageSizeOptions={[30, 50, 100, 200]}
          initialState={{ pagination: { paginationModel: { pageSize: 50 } } }}
          checkboxSelection
          disableRowSelectionOnClick
          onRowSelectionModelChange={(newRowSelectionModel, detail) => {
            let newModel = [];
            let sameLoadData = rowsData;
            if (newRowSelectionModel.length > rowSelectionModel.length) {
              const loadNumber = detail.api.getRow(
                newRowSelectionModel[0]
              ).LoadNumber;
              const filterLoadData = rowsData.filter(
                (data) => data.LoadNumber === loadNumber
              );
              sameLoadData = rowsData.map((data) => {
                if (data.LoadNumber === loadNumber) {
                  return {
                    ...data,
                    isSelectable: true,
                  };
                } else {
                  return {
                    ...data,
                    isSelectable: false,
                  };
                }
              });

              //rows = sameLoadData

              newModel = filterLoadData.map((data) => data.id);
            } else {
              newModel = [];
              sameLoadData = rowsData.map((data) => {
                return {
                  ...data,
                  isSelectable: true,
                };
              });
            }
            setRowSelectionModel(newModel);
            setRowsData(sameLoadData);
          }}
          rowSelectionModel={rowSelectionModel}
          isRowSelectable={(params) => params.row.isSelectable}
        />
      </div>

      <Snackbar open={open} onClose={handleClose}>
        <Alert
          severity={!error && apiMsg ? "success" : "error"}
          variant="filled"
          sx={{ width: "100%" }}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={handleClose}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          }
        >
          {apiMsg}
        </Alert>
      </Snackbar>
      <Drawer open={drawerOpen} onClose={toggleDrawer(false)} anchor="right">
        <div className="filter-drawer">
          <div className="filter-header-wrap">
            <span>Update Order Details</span>
            <IconButton aria-label="close" onClick={toggleDrawer(false)}>
              <CloseIcon />
            </IconButton>
          </div>
          <Grid container spacing={2}>
            <Grid item xs={12} sx={{ fontSize: "0.9rem", marginTop: "2rem" }}>
              <FormLabel htmlFor="load-number">Load Number</FormLabel>
              <div>
                <OutlinedInput
                  name="load-number"
                  placeholder="Enter Load Number"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                    },
                  }}
                  disabled={true}
                  value={loadNumberUpdate}
                  onChange={(e) => setLoadNumberUpdate(e.target.value)}
                />
              </div>
            </Grid>
            <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <FormLabel htmlFor="grouping-number">
                Missed Appt Yes/NO
              </FormLabel>
              <div>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={MissedAppt_Yes_NO}
                  label="Age"
                  onChange={(e) => setMissedAppt_Yes_NO(e.target.value)}
                  fullWidth
                >
                  <MenuItem value={"Yes"}>Yes</MenuItem>
                  <MenuItem value={"No"}>No</MenuItem>
                </Select>
              </div>
            </Grid>

            <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <FormLabel htmlFor="Missed-appt-notes">
                Missed appt notes
              </FormLabel>
              <div>
                <OutlinedInput
                  name="Missed-appt-notes"
                  placeholder="Missed appt notes"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                    },
                  }}
                  value={MissedApptNotes}
                  onChange={(e) => setMissedApptNotes(e.target.value)}
                  multiline={true}
                  rows={3}
                />
              </div>
            </Grid>

            <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <FormLabel htmlFor="Appointment-Time">Appt Rescheduled</FormLabel>
              <div>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateTimePicker
                    label=""
                    value={ApptRescheduled}
                    className="ml-8"
                    onChange={(newDailyValue) =>
                      setApptRescheduled(newDailyValue)
                    }
                    slotProps={{
                      textField: {
                        size: "small",
                        height: "0.3rem",
                        placeholder: "Appt Rescheduled",
                        fullWidth: true,
                      },
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        padding: "1px 10px 1px 0px",
                        // border: "1px solid #d1d4e2",
                      },
                      height: "0.3rem",
                    }}
                    slots={{ openPickerIcon: CalendarMonthOutlinedIcon }}
                  />
                </LocalizationProvider>
              </div>
            </Grid>

            {/* <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <FormLabel htmlFor="Appt-Rescheduled">Appt Rescheduled</FormLabel>
              <div>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={ApptRescheduled}
                  label="Age"
                  onChange={(e) => setApptRescheduled(e.target.value)}
                  fullWidth
                >
                  <MenuItem value={"Yes"}>Yes</MenuItem>
                  <MenuItem value={"No"}>No</MenuItem>
                </Select>
              </div>
            </Grid> */}

            <Grid item xs={12} sx={{ fontSize: "0.9rem", marginTop: "1.5rem" }}>
              <FormLabel htmlFor="Appt-Reschduled-notes">
                Appt Reschduled notes
              </FormLabel>
              <div>
                <OutlinedInput
                  name="Appt-Reschduled-notes"
                  placeholder="Appt Reschduled notes"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                    },
                  }}
                  value={ApptReschduledNotes}
                  onChange={(e) => setApptReschduledNotes(e.target.value)}
                  multiline={true}
                  rows={3}
                />
              </div>
            </Grid>

            <Grid item xs={12} md={12} sx={{ marginTop: "25px" }}>
              <Button variant="contained" onClick={handleUpdate} size="small">
                Update
              </Button>
            </Grid>
          </Grid>
        </div>
      </Drawer>
    </>
  );
};

export default RoutingRecieved;
